<template>
  <v-card v-ripple @click="click" class="clear my-navigate-button">
    <p>{{buttonText}}</p>
    <img src="../../../assets/images/btn-next.png" />
  </v-card>
</template>
<script>
export default {
  props: ['buttonText', 'routerName'],
  methods: {
    click() {
      this.$router.push({ name: this.routerName })
    }
  }
}
</script>
<style lang="scss" scoped>

.my-navigate-button {
  font-weight: 900;
  font-size: 18px;
  margin: 0 !important;
  width: 100%;

  img {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
